import { makeStyles } from 'tss-react/mui'
import bg from 'src/assets/images/aboutUs/notalonecardbg.jpg'
import { lato, nunito_sans } from '@styles/fonts'
const useStyles = makeStyles()((theme) => ({
  rootZenContainer: {
    background: 'none',
    border: '1px solid black',
  },
  rootContainer: {
    backgroundImage: `url(${bg?.src})`,
    minHeight: '450px',
    backgroundSize: '100% 100%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(15, 15, 18),
    borderRadius: '40px',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(8, 4),
      height: 'auto',
    },
    '@media (max-width:350px)': {
      padding: theme.spacing(6, 2),
    },
  },
  cardContent: {},
  imgContainer: {
    width: '150.83px',
    height: '150.83px',
    '@media (max-width:1248px)': {
      width: '126.83px',
      height: '126.83px',
    },
    [theme.breakpoints.down('md')]: {
      width: '95px',
      height: '95px',
    },

    '@media (max-width:370px)': {
      width: '70px',
      height: '70px',
    },
    '@media (max-width:350px)': {
      width: '50px',
      height: '50px',
    },
  },
  cardTextContainer: {
    marginLeft: theme.spacing(1),
  },
  name: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '32px',
    lineHeight: '34px',
    textTransform: 'uppercase',
    color: 'black',
    fontWeight: '900',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      marginBottom: theme.spacing(0),
    },
    '@media (max-width:350px)': {
      fontSize: '12px',
    },
  },
  age: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '20px',
    lineHeight: '34px',
    textTransform: 'uppercase',
    color: 'black',
    fontWeight: '600',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      marginBottom: theme.spacing(0),
    },
    '@media (max-width:350px)': {
      fontSize: '10px',
    },
  },
  description: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '24px',
    lineHeight: '34px',
    color: 'black',
    fontWeight: '400',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '22px',
    },
    '@media (max-width:350px)': {
      fontSize: '10px',
      lineHeight: '16px',
    },
  },
  secondaryText: {
    fontFamily: lato.style.fontFamily,
    fontSize: '16px',
    lineHeight: '19.2px',
    fontStyle: 'italic',
    fontWeight: '400',
    color: 'rgba(0,0,0,0.7)',
    '@media (max-width:350px)': {
      fontSize: '12px',
      lineHeight: '16px',
    },
  },
}))
export default useStyles
